import React, { useMemo } from 'react';
import _, { isArray } from 'lodash';
import bs from '../../../bsApp';
import {
  getBedOtherStatus,
  getBedStatus,
  getCubicleV2DisplayBedNo,
  getCubicleV2DisplayWardNo,
} from '../../../../../utils/newBedStatusUtil';
import VerticalBed from './VerticalBed';
import HorizontalBed from './HorizontalBed';
import BedWithPatientInfo from './BedWithPatientInfo';

const styles = (statusType, genderType, bedHead, isVertical) => {
  const gender = {
    [bs.MEN]: { rootBg: '#BAD2FF', bedNoFont: '#3673e4' },
    [bs.FEMALE]: { rootBg: '#FFD5E2', bedNoFont: '#f54c9d' },
    [bs.X]: { rootBg: '#BAD2FF', bedNoFont: '#7B80FF' },
    default: { rootBg: '#000', bedNoFont: '#fff' },
  };

  const _styles = {
    [bs.AVAILABLE]: { rootBg: '#A9EDDD', bedNoFont: '#00ac84' },
    [bs.OCCUPIED]: gender[genderType] ?? gender.default,
    [bs.DISCHARGING]: gender[genderType] ?? gender.default,
    [bs.TBC]: {
      rootBg: '#fff',
      bedNoFont: '#7d86a9',
      rootBorder: '0.09rem solid lightGray',
      boxBorder: 'lightGray',
      boxOpacity: '1',
    },
    [bs.UNAVAILABLE]: { rootBg: '#D0D3E0', bedNoFont: '#667098' },
    [bs.MISSING_CLOSED]: { rootBg: '#FFD983', bedNoFont: '#e49200' },
    [bs.MISSING]: { rootBg: '#FFF3BB', bedNoFont: '#dab609' },
  };

  const defaultStyles = { boxBorder: _styles[statusType] ? '#fff' : 'unset', rootBorder: 'unset', boxOpacity: '0.59' };
  return { ...defaultStyles, ..._styles[statusType], bedHead, isVertical };
};

export default function RevampStatusBed({
  bedNo,
  genderType,
  ward,
  allData = {},
  style,
  editFloorPlan = false,
  isVertical,
  showPatientName = false,
  status = '',
  isMutipleWardCode,
}) {
  const { linkedBedNo = '', linkeds = [], linkedId = '', bedHead = 'top', patInfo = {}, caseNo } = allData;
  const isLinked = useMemo(() => {
    if (linkedId) {
      return true;
    }
    return isArray(linkeds) && linkeds.length > 1;
  }, [linkeds, linkedId]);
  const typeName = useMemo(() => {
    // 把api返回字段和本地字段进行对应
    return getBedStatus(allData, editFloorPlan);
  }, [allData, editFloorPlan]);
  // 病床的状态 -> 对应api的字段
  const newRemarks = useMemo(() => {
    return getBedOtherStatus(allData, editFloorPlan);
  }, [allData, editFloorPlan]);

  const showHead = useMemo(() => {
    if (typeName === bs.OCCUPIED || typeName === bs.DISCHARGING) {
      return !_.some(newRemarks, (item) => item === bs.HOME_LEAVE || item === bs.HOME_LEAVE_OVERTIME);
    } else {
      return false;
    }
  }, [typeName, newRemarks]);

  const displayBedNo = getCubicleV2DisplayBedNo({ isLinked, linkedBedNo, status, bedNo });
  const displayWardNo = getCubicleV2DisplayWardNo({ isLinked, isMutipleWardCode, status, ward });

  if (showPatientName) {
    return (
      <BedWithPatientInfo
        patInfo={patInfo}
        caseNo={caseNo}
        style={style}
        styles={styles(typeName, genderType)}
        status={status}
        displayWardNo={displayWardNo}
        displayBedNo={displayBedNo}
      />
    );
  } else {
    return isVertical ? (
      <VerticalBed
        showHead={showHead}
        style={style}
        isLinked={isLinked}
        editFloorPlan={editFloorPlan}
        styles={styles(typeName, genderType, bedHead, isVertical)}
        displayBedNo={displayBedNo}
        displayWardNo={displayWardNo}
      />
    ) : (
      <HorizontalBed
        showHead={showHead}
        style={style}
        isLinked={isLinked}
        editFloorPlan={editFloorPlan}
        styles={styles(typeName, genderType, bedHead, isVertical)}
        displayBedNo={displayBedNo}
        displayWardNo={displayWardNo}
      />
    );
  }
}
